function loadImage(src : string){
  return new Promise<{height:number, width:number}>((resolve, reject) => {
    let img = new Image()
    img.onload = () => resolve({height : img.height, width : img.width})
    img.onerror = reject
    img.src = src
  })
}

export default loadImage;